/**
 * @typedef {Object} FileResource
 * @property {string} key - key for resource
 * @property {string} path - file path for resource
 * @property {string} type - The type of file(zip / others)
 * @property {number} file - file for type of (zip / others)
 */

/**
 * NOTE:
 * filePath -> key
 * fileUrl -> file
 */
const fileResourceListSingle = [];
const fileResourceMapSingle = {};

const addFileResource = (fileResource) => {
  fileResourceListSingle.push(fileResource);
  fileResourceMapSingle[fileResource.key] = fileResource;
};

const getFileResourceByKey = (key) => {
  return fileResourceMapSingle[key];
};

const getFileResourceList = () => {
  return fileResourceListSingle;
};

export default {
  addFileResource,
  getFileResourceByKey,
  getFileResourceList,
};
